import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { applyStoredTheme } from './state/theme';
import './styles/global.css';

// Before the first paint, so a light-theme user never sees a flash of dark.
applyStoredTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
